import React from "react";
import { Spin } from "antd";

interface LoadingSpinnerProps {
  showLoader: boolean;
  size?: "small" | "default" | "large";
  tip?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  showLoader = false,
  size = "default",
  tip = "Caricamento...",
}) => (
  <Spin
    fullscreen
    spinning={showLoader}
    tip={tip}
    size={size}
    style={{ pointerEvents: "all" }}
  />
);

export default LoadingSpinner;
